
$(function(){

var htmlContent = `<div class='wrapper-sticky-atc add-to-cart-sticky'>
<button class="btn btn--full atc"></button>
</div>`;

  // Append the HTML content to the end of the body
  let wrapperpresent = $('.wrapper-sticky-atc').length;
  if (wrapperpresent == 0) {
    $("body").append(htmlContent);
  }
  $('.wrapper-sticky-atc').hide();

  //if desktop, also insert the title.
    function desktoppaddingset() {
      var innerWidth = window.innerWidth;
      if (innerWidth > 1400) {
        var differenceforpadding = (innerWidth - 1420) / 2;
      }
      else if (innerWidth > 769 && innerWidth <= 1400) {
        var differenceforpadding = 40;
      }
      // Set a CSS variable
      document.documentElement.style.setProperty('--desktop-sticky-padding', differenceforpadding + 'px');
    }

    desktoppaddingset();

    //inserts with style.
    var prodtitle = $(".h2.product-single__title:first").html();
    var desktoptitle = $('<div class="prod-title h2 product-single__title"></div>'); // Create a div element with class prod-title
    desktoptitle.append(prodtitle); // Append the cloned title element to the created div

    let titlepresent = $('.wrapper-sticky-atc .h2.product-single__title').length;
    if (titlepresent == 0) {
      $('.wrapper-sticky-atc').prepend(desktoptitle); // Prepend the created div to the wrapper-sticky-atc element
    }

  // Function to clone just the inner span and insert it into sticky container
  function cloneInnerSpanAndInsert() {
    var innerSpan = $('.add-to-cart').find('span').html();
    $('.wrapper-sticky-atc button').html("<span>" + innerSpan + "</span>");
  }

  // Call the function initially
  cloneInnerSpanAndInsert();

  // ATC function.
  $('.wrapper-sticky-atc button').on('click', function () {
    $('.add-to-cart').trigger('click');
  });

  //observe ATC button and update new one accordingly.
  var targetNode = $(".add-to-cart")[0];

  var observer = new MutationObserver(function (mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        cloneInnerSpanAndInsert();
      }
    }
  });

  var config = { attributes: true, childList: true, subtree: true };

  observer.observe(targetNode, config);

  //run the logic. Mobile vs desktop?
  function hideScroller() {
    actionbtn = $('.add-to-cart');
    var sub = $('.wrapper-sticky-atc');
    actionfromtop = actionbtn.offset().top + 790;
    subfromtop = $(window).scrollTop() + $(window).height();

    if (actionfromtop > subfromtop) { sub.fadeOut(150); }
    else { sub.fadeIn(150); }
  }

  $(document).ready(function () {
    $('.wrapper-sticky-atc').hide();
    hideScroller();

  });

  $(window).scroll(function () {
    hideScroller();
  });

  $(window).on('resize', function () {
    desktoppaddingset();
  });

  
});

